import { updateOrderAction } from '../updateOrderAction';

export const handleUpdateOrder = (dispatch, orderResponse) =>
    dispatch(updateOrderAction(orderResponse));
